import { useContext, useEffect, useState } from "react";
import { Context } from "../context";
import { useParams } from "react-router-dom";
import { Avatar, Button, Card, Divider, Popover, Spin, Tag } from "antd";
import he from '../../node_modules/axe-core/locales/he.json';
import { LayoutGrid } from './LayoutGrid';
import { ProjectsGrid } from "./ProjectsGrid";
import VideoEmbed from "./VideoEmbed";
import Badge from './Badge';
import { BadgeActive } from './Badge';
import { GlobalOutlined, LinkedinFilled, MailFilled, MailOutlined } from "@ant-design/icons";
import { AccoladeGallery, AccoladeGalleryActive } from "./AccoladeGallery";
import { Mention } from "./Mention";
import { AlumniUrl } from "../AlumniUrl";

export function Alumni(props) {

  const context = useContext(Context);
  const { alumni } = useParams();
  const alumniHandle = alumni;
  const { x } = context;
  const alumnuData = context.x.getAlumniByHandle(alumniHandle);
  // const alumniHandle = alumni.replace('@', '');

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);




  const [reel, setReel] = useState(alumnuData ? {
    url: alumnuData.demoReel,
    cover: alumnuData.demoReelCover
  } : {});

  useEffect(() => {
    if (alumnuData) {
      setReel({
        url: alumnuData.demoReel,
        cover: alumnuData.demoReelCover
      });
    }
  }, [alumnuData]);


  const getTerm = (alumnuData) => {

    const TERMS = {
      'FA': 'Fall',
      'SP': 'Spring',
      'SU': 'Summer',
      'WI': 'Winter',
    }
    return <><strong>{`${TERMS[alumnuData.startTerm.slice(0, 2)]} ${alumnuData.startTerm.split(' ')[1]}`}</strong>&nbsp;to&nbsp;<strong>{`${TERMS[alumnuData.endTerm.slice(0, 2)]} ${alumnuData.endTerm.split(' ')[1]}`}</strong></>;
  }

  const program = (alumnuData) => {
    switch (alumnuData.program) {
      case 'Cert DP':
        return {
          'url': 'https://www.gnomon.edu/academics/certificate-digital-production/',
          'title': 'Certificate in Digital Production'
        };
      case 'BFA DP':
        return {
          'url': 'https://www.gnomon.edu/programs/digital-production-bachelor-of-fine-arts/',
          'title': 'Bachelor of Fine Arts in Digital Production'
        };
      default:
        return alumnuData.program; // Return the original program if no match is found
    }
  };



  useEffect(() => {
    const alumniData = context.x.getAlumniByHandle(alumniHandle);
    if (alumniData) {
      document.title = `Gnomon Alumni - ${alumniData.name}`;
    }
  }, [alumni, context]);

  return (
    <>
      {alumnuData && <>

        <div className="_fv _f100" style={{ padding: '0 0 2em 0' }}>

          <div className="x_reel_alumni">

            <div className="x_reel _rel">
              <Card
                cover={<div
                  className="x_reel_shadow _rel"
                >

                  <div
                    className="x_reel_shadow _rel"
                    style={{
                      backgroundImage: `url(${reel.cover})`,
                      zIndex: 2,
                    }} />

                  <div className="preloader _fcc"><Spin /></div>


                </div>}
              >


              </Card>



              {Boolean(reel.url) && <VideoEmbed
                demoReel={reel.url}
                style={{
                  position: 'absolute',
                  zIndex: 100,
                  top: 0,
                  left: 0,
                  width: '100%',
                  objectFit: 'cover',
                  aspectRatio: '16/9',
                }}
              />}


              {alumnuData.accolades.length > 0 && <div className="alumni_accolades _f _fwrap _fgapx1 _fgapy2  _f100">




                <div className={`accolade_gallery0 accolade_gallery0_page _backzoom0 ${reel.cover === alumnuData.demoReelCover ? 'accolade_gallery0_active' : ''}`}
                  onClick={() => {
                    setReel({
                      url: alumnuData.demoReel,
                      cover: alumnuData.demoReelCover
                    });
                  }}
                >
                  <AccoladeGalleryActive active={reel.url === alumnuData.demoReel} />
                  <div
                    className='accolade_gallery_thumb '
                    style={{ backgroundImage: `url(${alumnuData.demoReelCover}/m/300x150)` }}
                  />
                  <div className="accolade_gallery_page_title ">Demo reel</div>

                </div>



                {alumnuData.accolades.map(accoladeId => {
                  const data = x.getAccoladeById(accoladeId);
                  return <AccoladeGallery
                    key={`accolade_gallery2_${accoladeId}_${alumnuData._id}`}
                    active={data && reel.url === data.embed && reel.cover === data.thumbnail}
                    onClick={() => {
                      data && setReel({
                        url: data.embed,
                        cover: data.thumbnail
                      });
                    }}
                    page={true}
                    one={data}
                    alumnuData={alumnuData}
                  />
                }
                )}

              </div>}


            </div>

            <div className="x_alumni _fv  _fgapx04 _fgapy1">



              <div className="_f _fwrap _fgapx04 _fgapy1 _fm">
                <h1 className="_f _fwrap _fgap04 _fm _fgrow">
                  <Avatar
                    style={{
                      backgroundColor: '#ffd20b6b',
                      flexShrink: 0,
                      color: '#000000',
                      // backgroundImage: alumnuData.headshot[0] ? `url(${alumnuData.headshot[0].thumbnails.small.url})` : '',
                      backgroundImage: `url(${alumnuData.headshot})`,
                      backgroundSize: 'cover',
                      backgroundPosition: '50% 50%',
                      filter: 'grayscale(100%)',
                      borderRadius: '0%',
                      backgroundColor: '#ffd40b',
                      color: '#000',
                      border: '0',
                      '--angleSize': '4px',
                      clipPath: 'polygon(0 var(--angleSize), var(--angleSize) 0, 100% 0, 100% calc(100% - var(--angleSize)), calc(100% - var(--angleSize)) 100%, 0 100%)',
                      padding: '0.4em 2em !important',
                      cursor: 'pointer'
                    }}
                    size={42}
                  >
                    <b>{!alumnuData.headshot && alumnuData.name.charAt(0)}</b>
                  </Avatar>

                  {alumnuData.name}</h1>

              </div>



              <div className="_f _fgapx2 _fgapy1 _fwrap"
                style={{
                  // fontSize: '1.2em',
                  // lineHeight: '1.4em'
                }}
              >
                {Boolean(alumnuData.location)
                  && <div>Location: <b>{alumnuData.location}</b></div>}


                <div className="_f _f100 _fgapx2 _fgapy2 _fwrap">
                  <Popover
                    placement="bottomLeft"
                    content={
                      <div className="_fv _fgap1 _fwrap _fleft">
                        {/* {Boolean(alumnuData.email1) && <div className="_fcc _fgap04"><MailFilled className="y" style={{ fontSize: '16px' }} /><a href={`mailto:${alumnuData.email1}`}>{alumnuData.email1}</a></div>} */}
                        {/* {Boolean(alumnuData.email2) && <div className="_fcc _fgap04"><MailFilled className="y" style={{ fontSize: '16px' }} /><a href={`mailto:${alumnuData.email2}`}>{alumnuData.email2}</a></div>} */}
                        {Boolean(alumnuData.linkedIn) &&
                          <Button className="_fm _fleft y"
                            onClick={() => {
                              window.open(alumnuData.linkedIn, '_blank');
                            }}
                          >
                            <div className="_fm _fgap04"><LinkedinFilled className="y" style={{ fontSize: '16px' }} /><span className="">LinkedIn</span></div>
                          </Button>
                        }
                        {Boolean(alumnuData.website) &&
                          <Button className="_f _fm _fleft y"
                            onClick={() => {
                              window.open(alumnuData.website, '_blank');
                            }}
                          >
                            <div className="_fm _fgap04"><GlobalOutlined className="y" style={{ fontSize: '16px' }} /><span className="">Website</span></div>
                          </Button>
                        }
                      </div>
                    } trigger="click">
                    <Button type="primary" className="button-gnomon">
                      Connect with {alumnuData.name.split(' ')[0]}
                    </Button>
                  </Popover>
                </div>




                {Boolean(alumnuData.software) && <div className='_fwrap _fgap04'>
                  {alumnuData.software.map(one => <Tag className="tag_software angle" key={`tag_software_${one}_${alumnuData._id}`}>{one}</Tag>)}
                </div>}



              </div>


              {/* <Divider /> */}

              <div className="_fv _fgapx2 _fgapy1 "
              // style={{ fontSize: '1.2em', lineHeight: '1.4em' }}
              >
                <div className="_fm _fwrap">
                  Gnomon student from&nbsp;{Boolean(alumnuData.startTerm) && getTerm(alumnuData)}
                </div>
                <div className="">
                  {Boolean(alumnuData.program) && <div>Program: <b><a href={program(alumnuData).url} className="link" target="_blank" rel="noopener noreferrer">{program(alumnuData).title}</a></b></div>}
                </div>


                {alumnuData.accolades.length > 0 &&
                  <div className="_fv _fgapx2 _fgapy04 _f100">
                    Accolades:
                    <div
                      className="_f _fwrap _f100"
                    >
                      {alumnuData.accolades.map(accoladeId =>
                        <Badge
                          key={`badge2_${accoladeId}_${alumnuData._id}`}
                          one={x.getAccoladeById(accoladeId)}
                          alumnuData={alumnuData}
                          page={true}
                        />
                      )}
                    </div>
                  </div>
                }


                {alumnuData.mentions.length > 0 &&
                  <div className="_fv _fgapx2 _fgapy04 _f100">
                    Mentions:
                    <div
                      className="_fv _fgap1"
                    >
                      {alumnuData.mentions.map(mentionId =>
                        <Mention key={`mention_${mentionId}_${alumnuData._id}`} {...context.x.getMentionById(mentionId)} />
                      )}
                    </div>
                  </div>
                }

              </div>


            </div>



          </div>
          <Divider />

          <AlumniUrl alumniHandle={alumniHandle} />

        </div>

      </>}
    </>
  )
}
